import React from 'react';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { SINGLE } from '../../constants/paymentFrequency';
import AutomaticRecurringPaymentScheduleTable from '../../components/AutomaticRecurringPaymentScheduleTable';
import RequiredStar from '../../components/FormComponents/RequiredStar';
import { ATTACHMENT_EXTENSIONS, ATTACHMENT_TYPES } from '../../constants';

export const getPaymentSchedule = (paymentFrequency, scheduleData, scheduleTitles, t) => {
  const content = (
    <>
      {
        Object.keys(scheduleData).map((key) => (
          <AutomaticRecurringPaymentScheduleTable
            key={key}
            title={scheduleTitles[key]}
            paymentSchedule={scheduleData[key]}
          />
        ))
      }
    </>
  );

  const block = [{
    key: 'paymentSchedule',
    title: t('insurance.paymentSchedule'),
    icon: faCalendarCheck,
    content,
  }];
  return paymentFrequency.code === SINGLE ? [] : block;
};

const {
  PASSPORT,
  REFERENCE,
  EXTRACT_FROM_OUTPATIENT_CARD,
  EPICRISIS,
  OTHER,
  CASH_REGISTER_RECEIPT,
  AMOUNT,
  DM_CHECK,
  DISABILITY_FORM,
  POLICE_REPORT,
  OWNER_CERTIFICATE,
  LOAN_AGREEMENT,
  POWER_OF_ATTORNEY,
  DRIVER_LICENSE,
  TECH_PASSPORT,
  DOCUMENT_CERTIFYING_RIGHT,
  PHOTO,
} = ATTACHMENT_TYPES;

export const bindMedicalAttachmentsOptions = (t) => [
  {
    id: 1,
    name: PASSPORT,
    title: (
      <span>
        {t('claim.attachments.passport')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    id: 2,
    name: REFERENCE,
    hasSectionTitle: true,
    sectionTitle: t('claim.attachments.medicalJustification'),
    title: (
      <span>
        {t('claim.attachments.reference')}
      </span>
    ),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
    accept: ATTACHMENT_EXTENSIONS.any,
  },
  {
    id: 3,
    name: EPICRISIS,
    title: (
      <span>
        {t('claim.attachments.epicrisis')}
      </span>
    ),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
    accept: ATTACHMENT_EXTENSIONS.any,
  },
  {
    id: 4,
    name: EXTRACT_FROM_OUTPATIENT_CARD,
    title: (
      <span>
        {t('claim.attachments.extractFromOutpatientCard')}
      </span>
    ),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
    accept: ATTACHMENT_EXTENSIONS.image,
  },
  {
    id: 5,
    name: CASH_REGISTER_RECEIPT,
    hasSectionTitle: true,
    sectionTitle: t('claim.attachments.proofOfPayment'),
    title: (
      <span>
        {t('claim.attachments.cashRegisterReceipt')}
        <RequiredStar />
      </span>
    ),
    icon: 'image',
    accept: ATTACHMENT_EXTENSIONS.any,
  },
  {
    id: 6,
    name: AMOUNT,
    title: t('claim.attachments.amount'),
    icon: 'image',
    accept: ATTACHMENT_EXTENSIONS.any,
  },
  {
    id: 7,
    name: DM_CHECK,
    title: t('claim.attachments.dmCheck'),
    icon: 'image',
    accept: ATTACHMENT_EXTENSIONS.any,
  },
  {
    id: 8,
    name: OTHER,
    title: t('claim.attachments.other'),
    icon: 'image',
    accept: ATTACHMENT_EXTENSIONS.any,
  },
];

export const bindTravelAttachmentsOptions = (t) => [
  {
    id: 1,
    name: PASSPORT,
    title: (
      <span>
        {t('claim.attachments.passport')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    id: 2,
    name: REFERENCE,
    title: t('claim.attachments.reference'),
    hasSectionTitle: true,
    sectionTitle: t('claim.attachments.medicalJustification'),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
  },
  {
    id: 3,
    name: EPICRISIS,
    title: t('claim.attachments.epicrisis'),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
  },
  {
    id: 4,
    name: EXTRACT_FROM_OUTPATIENT_CARD,
    title: t('claim.attachments.extractFromOutpatientCard'),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
  },
  {
    id: 5,
    name: CASH_REGISTER_RECEIPT,
    title: (
      <span>
        {t('claim.attachments.cashRegisterReceipt')}
        <RequiredStar />
      </span>
    ),
    hasSectionTitle: true,
    sectionTitle: t('claim.attachments.proofOfPayment'),
    icon: 'file',
  },
  {
    id: 6,
    name: AMOUNT,
    title: t('claim.attachments.amount'),
    icon: 'file',
  },
  {
    id: 7,
    name: DM_CHECK,
    title: t('claim.attachments.dmCheck'),
    icon: 'file',
  },
  {
    id: 8,
    name: OTHER,
    title: t('claim.attachments.other'),
    icon: 'file',
  },
];

export const bindAccidentAttachmentsOptions = (t) => [
  {
    id: 1,
    name: PASSPORT,
    title: (
      <span>
        {t('claim.attachments.passport')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    id: 2,
    name: DISABILITY_FORM,
    title: t('claim.attachments.disabilityForm'),
    icon: 'file',
  },
  {
    id: 3,
    name: POLICE_REPORT,
    title: (
      <span>
        {t('claim.attachments.policeReport')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    id: 4,
    name: REFERENCE,
    title: t('claim.attachments.reference'),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    hasSectionTitle: true,
    sectionTitle: t('claim.attachments.medicalJustification'),
    icon: 'file',
  },
  {
    id: 5,
    name: EPICRISIS,
    title: t('claim.attachments.epicrisis'),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
  },
  {
    id: 6,
    name: EXTRACT_FROM_OUTPATIENT_CARD,
    title: t('claim.attachments.extractFromOutpatientCard'),
    description: t('claim.attachments.referenceNotRequiredLabel'),
    icon: 'file',
  },
  {
    id: 7,
    name: CASH_REGISTER_RECEIPT,
    title: (
      <span>
        {t('claim.attachments.cashRegisterReceipt')}
        <RequiredStar />
      </span>
    ),
    hasSectionTitle: true,
    sectionTitle: t('claim.attachments.proofOfPayment'),
    icon: 'file',
  },
  {
    id: 8,
    name: AMOUNT,
    title: t('claim.attachments.amount'),
    icon: 'image',
  },
  {
    id: 9,
    name: DM_CHECK,
    title: t('claim.attachments.dmCheck'),
    icon: 'image',
  },
  {
    id: 10,
    name: OTHER,
    title: t('claim.attachments.other'),
    icon: 'image',
  },
];

export const bindCascoAttachmentsOptions = (initialData, attachmentConstraints, t) => [
  {
    id: 1,
    name: PASSPORT,
    title: (
      <span>
        {t('claim.attachments.passport')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    id: 2,
    name: DRIVER_LICENSE,
    title: (
      <span>
        {t('claim.attachments.driverLicense')}
        {attachmentConstraints.requiredTypes.indexOf(DRIVER_LICENSE) !== -1 && (
          <RequiredStar />
        )}
      </span>
    ),
    icon: 'file',
  },
  {
    id: 3,
    name: TECH_PASSPORT,
    title: (
      <span>
        {t('claim.attachments.techPassport')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    id: 4,
    name: DOCUMENT_CERTIFYING_RIGHT,
    title: (
      <span>
        {t('claim.attachments.documentCertifyingRight')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    id: 5,
    name: PHOTO,
    title: (
      <span>
        {t('claim.attachments.photo')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  {
    ...((!initialData.isPhysicalEntity
        || initialData.isOtherApplicant
        || initialData.isOtherPaymentReceiver) && {
      id: 6,
      name: POWER_OF_ATTORNEY,
      title: (
        <span>
          {t('claim.attachments.powerOfAttorney')}
          {initialData.isOtherPaymentReceiver || initialData.isPhysicalEntity
            ? <RequiredStar />
            : null}
        </span>
      ),
      icon: 'file',
    }),
  },
  {
    id: 7,
    name: OTHER,
    title: t('claim.attachments.other'),
    icon: 'image',
  },
];

export const bindPropertyAttachmentsOptions = (
  initialData,
  t,
) => [
  {
    id: 1,
    name: PASSPORT,
    title: t('claim.attachments.passport'),
    icon: 'file',
  },
  {
    id: 2,
    name: OWNER_CERTIFICATE,
    title: (
      <span>
        {t('claim.attachments.ownerCertificate')}
        <RequiredStar />
      </span>
    ),
    icon: 'file',
  },
  { ...(initialData.hasLoanAgreement && {
    id: 4,
    name: LOAN_AGREEMENT,
    title: t('claim.attachments.loanAgreement'),
    icon: 'file',
  }),
  },
  { ...((!initialData.isPhysicalEntity
        || initialData.isOtherApplicant
        || initialData.isOtherPaymentReceiver) && {
    id: 5,
    name: POWER_OF_ATTORNEY,
    title: (
      <span>
        {t('claim.attachments.powerOfAttorney')}
        {initialData.isOtherPaymentReceiver || initialData.isPhysicalEntity
          ? <RequiredStar />
          : null}
      </span>
    ),
    icon: 'file',
  }),
  },
  {
    id: 6,
    name: OTHER,
    title: t('claim.attachments.other'),
    icon: 'image',
    accept: ATTACHMENT_EXTENSIONS.any,
  },
];
